export default __webpack_public_path__ + "static/media/mrge.618b83a7.jfif";